import { render, staticRenderFns } from "./MFA_QRCode.vue?vue&type=template&id=96338254&scoped=true"
import script from "./MFA_QRCode.vue?vue&type=script&lang=ts"
export * from "./MFA_QRCode.vue?vue&type=script&lang=ts"
import style0 from "./MFA_QRCode.vue?vue&type=style&index=0&id=96338254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96338254",
  null
  
)

export default component.exports